<template>
  <div class="devicp">
    <!-- <div class="linshi"></div> -->
    <div class="left">
      <div class="yuan-left"></div>
      <div class="information">
        <div class="title">
          <span>压力分析</span>
        </div>
        <ul>
          <li><span>编号：</span> {{ this.getAnalysisData.number }}</li>
          <li><span>型号：</span> {{ this.getAnalysisData.model }}</li>
          <li><span>量程 ：</span> {{ this.getAnalysisData.range }}OM3/H</li>
          <li><span>工作压力：</span>{{ this.getAnalysisData.workPs }}MPA</li>
          <li>
            <span>介质温度：</span> {{ this.getAnalysisData.Temperature }}
          </li>
          <li><span>位置：</span> {{ this.getAnalysisData.Position }}</li>
        </ul>
      </div>
      <div class="flow">
        <div class="line"></div>
        <div class="state">
          <div>状态：</div>
          <span
            v-for="(item, index) in stateData"
            :key="index"
            :class="getStateData.State == item ? 'stateActive' : ''"
            >{{ item }}/</span
          >
        </div>
        <ul>
          <li>
            <div>
              <span>流量总累计：</span
              ><span v-if="this.getStateData[0]">{{
                this.getStateData[0].totalFlow
              }}</span>
            </div>
            <span>M3</span>
          </li>
          <li>
            <div>
              <span>当月流量：</span
              ><span v-if="this.getStateData[0]">{{
                this.getStateData[0].MounthFlow
              }}</span>
            </div>
            <span>M3</span>
          </li>
          <li>
            <div>
              <span>当日流量：</span
              ><span v-if="this.getStateData[0]">{{
                this.getStateData[0].DayFlow
              }}</span>
            </div>
            <span>M3</span>
          </li>
        </ul>
      </div>
      <div class="devic-warning">
        <div class="line"></div>
        <div class="ul-title">
          <span>序号</span>
          <span>日期</span>
          <span>时间</span>
          <span>报警事件</span>
          <span>恢复时间</span>
        </div>
        <ul>
          <li v-for="(item, index) in this.getAlarmData" :key="index">
            <span>{{ index + 1 }}</span>
            <span>{{ item.data }}</span>
            <span>{{ item.happenTime }}</span>
            <span>{{ item.type }}</span>
            <span>{{ item.recoveryTime }}</span>
          </li>
        </ul>
      </div>
      <div class="min-pa">
        <div class="line"></div>
        <MinPa :needData="this.getEquipmentStatisticalAnalysisData"></MinPa>
      </div>
    </div>
    <div class="right">
      <!-- <div class="back" @click="back()"></div> -->
      <div class="yuan-right"></div>
      <div class="yuan-data">
        <ul class="ulOne">
          <li
            v-for="(item, index) in yuanDataOne"
            :key="index"
            :class="
              num == 0
                ? getEquipmentAlarmData.Alarm1 != item
                  ? 'dengActive'
                  : 'dengActiveRed'
                : ''
            "
          >
            <span>{{ item }}</span>
          </li>
        </ul>
        <ul class="ulTwo">
          <li
            v-for="(item, index) in yuanDataTwo"
            :key="index"
            :class="
              num == 1
                ? getEquipmentAlarmData.Alarm1 != item
                  ? 'dengActive'
                  : 'dengActiveRed'
                : ''
            "
          >
            <span>{{ item }}</span>
          </li>
        </ul>
        <ul class="ulThree">
          <li
            v-for="(item, index) in yuanDataThree"
            :key="index"
            :class="
              num == 2
                ? getEquipmentAlarmData.Alarm1 != item
                  ? 'dengActive'
                  : 'dengActiveRed'
                : ''
            "
          >
            <span>{{ item }}</span>
          </li>
        </ul>
        <ul class="ulFour">
          <li
            v-for="(item, index) in yuanDataFour"
            :key="index"
            :class="
              num == 3
                ? getEquipmentAlarmData.Alarm1 != item
                  ? 'dengActive'
                  : 'dengActiveRed'
                : ''
            "
          >
            <span>{{ item }}</span>
          </li>
        </ul>
        <ul class="ulFive">
          <li
            v-for="(item, index) in yuanDataFive"
            :key="index"
            :class="
              num == 4
                ? getEquipmentAlarmData.Alarm1 != item
                  ? 'dengActive'
                  : 'dengActiveRed'
                : ''
            "
          >
            <span>{{ item }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="computer">
      <div class="abox-line"></div>
      <ul>
        <li :class="{ active: num == 0 }">
          <img
            src="../assets/img/mcu.png"
            style="width: 44px; height: 43px"
            alt=""
          />
          <span class="title" style="fontsize: 13px">MCU</span>
        </li>
        <li :class="{ active: num == 1 }">
          <img
            src="../assets/img/tongxing.png"
            style="width: 55px; height: 43px"
            alt=""
          />
          <span class="title" style="fontsize: 13px">通信</span>
        </li>
        <li :class="{ active: num == 2 }">
          <img
            src="../assets/img/dianluban.png"
            style="width: 40px; height: 43px"
            alt=""
          />
          <span class="title" style="fontsize: 13px">电路板</span>
        </li>
        <li :class="{ active: num == 3 }">
          <img
            src="../assets/img/chuangganqi.png"
            style="width: 60px; height: 43px"
            alt=""
          />
          <span class="title" style="fontsize: 13px">传感器</span>
        </li>
        <li :class="{ active: num == 4 }">
          <img
            src="../assets/img/keti.png"
            style="width: 30px; height: 43px"
            alt=""
          />
          <span class="title">壳体</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {
//getAnalysis,
//getState,
//getAlarm,
//getEquipmentStatisticalAnalysis,
//getEquipmentAlarm,
} from "../api/equipment";
import MinPa from "../components/MinPa";
export default {
  name: "devicp",
  data() {
    return {
      num: 0,
      stateData: ["正常", "停机维护", "预警", "报警"],
      // yuanData: [
      //   "EEPROM故障",
      //   "参考电容过大",
      //   "参考电容过小",
      //   "高压仓电容过大",
      //   "高压仓电容过小",
      //   "低压仓电容过大",
      //   "低压仓电容过小",
      //   "双温度传感器温差",
      //   "测温电路漂移",
      //   "采集板电源异常",
      // ],
      yuanDataOne: ["EEPROM故障"],
      yuanDataTwo: ["参考电容过大", "参考电容过小"],
      yuanDataThree: [
        "高压仓电容过大",
        "高压仓电容过小",
        "低压仓电容过大",
        "低压仓电容过小",
      ],
      yuanDataFour: ["双温度传感器温差"],
      yuanDataFive: ["测温电路漂移", "采集板电源异常"],
      timer: null,
      getAnalysisData: "", //分析
      getStateData: "", //状态
      getAlarmData: "", //告警
      getEquipmentStatisticalAnalysisData: "", //设备统计分析
      getEquipmentAlarmData: "", //设备告警类别
    };
  },
  components: { MinPa },
  props: ["needData"],
  mounted() {
    this.Highlight();
    this.equipmentData(this.needData);
  },
  watch: {},
  methods: {
    equipmentData() {
//    let param = {
//      devId: id,
//    };
      // console.log(param, "设备id");
      //分析
//    getAnalysis(param).then((res) => {
//         console.log(res.data, "气体分析");
        this.getAnalysisData = {"Position": "北环-流量计3",
																"Temperature": "0~40℃",
																"model": 4,
																"number": 8,
																"range": "5-70",
																"type": 0};
//    });

      //状态
//    getState(param).then((res) => {
//         console.log(res.data, "气体状态");
        this.getStateData = {0: {"DayFlow": 238,"MounthFlow": 7849,"totalFlow": 14374}, "State": '正常'};
//    });

      //告警
//    getAlarm(param).then((res) => {
//         console.log(res.data, "气体告警");
        this.getAlarmData = [{"serialNum ": '1', "data": '2022-07-18', "happenTime": '06:50:26', "type": '预警', "recoveryTime": '10:50:47'},{"serialNum ": '2', "data": '2022-07-18', "happenTime": '06:50:26', "type": '预警', "recoveryTime": '10:50:47'},{"serialNum ": '3', "data": '2022-07-18', "happenTime": '06:50:26', "type": '预警', "recoveryTime": '10:50:47'}];
//    });

      //设备统计分析
//    getEquipmentStatisticalAnalysis(param).then((res) => {
//         console.log(res.data, "气体设备统计分析");
        this.getEquipmentStatisticalAnalysisData = [{"highest": 197,
																											"minimum": 104,
																											"month": 1,
																											"standard": 269}, {"highest": 392,
																											"minimum": 108,
																											"month": 2,
																											"standard": 275}, {"highest": 358,
																											"minimum": 114,
																											"month": 3,
																											"standard": 267}, {"highest": 285,
																											"minimum": 102,
																											"month": 4,
																											"standard": 200}, {"highest": 298,
																											"minimum": 107,
																											"month": 5,
																											"standard": 267}, {"highest": 285,
																											"minimum": 118,
																											"month": 6,
																											"standard": 175}];
//    });

      //设备告警类别
      
//      getEquipmentAlarm(param).then((res) => {
//         console.log(res.data, "气体设备告警类别");
        this.getEquipmentAlarmData = {"Name": '', "Alarm1": ''};
//    });
      
      
    },
    Highlight() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        var that = this;
        that.num++;

        if (that.num == 5) {
          that.num = 0;
        }
        this.Highlight();
      }, 5000);
    }
    // back(){
    //   this.$router.push({
    //     path:'/'
    //   });
    //   document.getElementById("iframe").contentWindow.MMAPI.show1(0);
    //   // document.getElementById('iframe').contentWindow.MMAPI.show(true)
    //   // this.bottomShow = true;
    // }
  },
  destroyed() {
    clearTimeout(this.timer);
  },
};
</script>
<style scoped>
.devicp {
  width: 100%;
  height: 100%;
  z-index: 5;
  position: absolute;
}

.linshi {
  width: 300px;
  height: 498px;
  position: absolute;
  background: url("../assets/img/536.png") no-repeat;
  background-size: 100% 100%;
  left: 32%;
  top: 20%;
}

.computer {
  width: 22.1vw;
  height: 66vh;
  position: absolute;
  top: 18vh;
  right: 24vw;
}
.abox-line {
  position: absolute;
  top: 2.5vw;
  left: 0;
  width: 15vw;
  height: 54vh;
  background: url("../assets/img/computer.png") no-repeat;
  background-size: 100% 100%;
  /* background: red; */
}
.computer ul {
  width: 14vw;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  /* background: blue; */
}
.computer ul li {
  width: 6.5vw;
  height: 8.8vh;
  background: url("../assets/img/computerli.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  align-items: center;
  color: #eceeef;
}
.computer ul li img {
  margin-top: 1vh;
}
.computer ul li span {
  font-size: 13px;
  margin-bottom: 1vh;
}
.computer ul li:nth-child(1) {
  position: absolute;
  top: 0.8vh;
  left: 2.6vw;
}
.computer ul li:nth-child(2) {
  position: absolute;
  left: 6vw;
  top: 14vh;
}
.computer ul li:nth-child(3) {
  position: absolute;
  left: 7vw;
  top: 27vh;
}
.computer ul li:nth-child(4) {
  position: absolute;
  left: 6.4vw;
  top: 41vh;
}
.computer ul li:nth-child(5) {
  position: absolute;
  left: 2.6vw;
  top: 54vh;
}
.computer ul li.active {
  background: url("../assets/img/mcuActive.png") no-repeat;
  z-index: 55;
}
.left {
  width: 17.7%;
  height: 86vh;
  margin-top: 9.25vh;
}
.yuan-left {
  position: absolute;
  width: 12.81vw;
  height: 81vh;
  background: url("../assets/img/yuan-left.png") no-repeat;
  background-size: 100% 100%;
  margin-top: 4.1vh;
  left: 19.27vw;
  pointer-events: none;
}

.left div .title {
  width: 35.55vw;
  height: 2.6vh;
  margin-left: 0.7vw;
  background: url("../assets/img/title.png") no-repeat;
}
.left div .title span {
  font-size: 0.75vw;
  color: white;
  display: flex;
  margin-left: 2.1vw;
  height: 1.1vh;
  line-height: 2.4vh;
  font-family: pangmenzhengdao;
}

.left div .line {
  width: 35.55vw;
  height: 0.2vh;
  margin-left: 0.7vw;
  background: url("../assets/img/line.png") no-repeat;
}

.information {
  width: 100%;
  height: 20vh;
}

.information ul {
  width: 100%;
  height: 18vh;
  margin-top: 1.5vh;
}

.information ul li {
  width: 16.15vw;
  height: 2.7vh;
  margin-left: 0.6vw;
  font-size: 0.7vw;
  color: #fff;
  background: url("../assets/img/devic-li.png") no-repeat;
  display: flex;
  line-height: 1vh;
  font-family: SIMHEI;
}

.information ul li span {
  color: #afeeff;
  margin-left: 1vw;
  font-family: SIMHEI;
}

.flow {
  width: 100%;
  height: 22.5vh;
  /* background: red; */
}

.flow .state {
  width: 100%;
  height: 2.8vh;
  display: flex;
  margin-left: 0.7vw;
  line-height: 2.8vh;
  color: #fff;
  font-size: 0.7vw;
  font-family: SIMHEI;
}

.flow .state div:nth-child(1) {
  color: #afeeff;
}
.flow .state span.stateActive {
  color: #afeeff;
}

.flow ul {
  width: 100%;
  height: 20vh;
}

.flow ul li {
  width: 100%;
  height: 2.9vh;
  margin-bottom: 1vh;
  margin-left: 0.7vw;
  display: flex;
  align-items: center;
}

.flow ul li div {
  width: 15.6vw;
  height: 100%;
  background: url("../assets/img/flow-li.png") no-repeat;
  display: flex;
  justify-content: space-between;
  line-height: 2.6vh;
}
.flow ul li span {
  color: #fff;
  font-size: 0.7vw;
  font-family: SIMHEI;
}

.flow ul li div span:nth-child(1) {
  margin-left: 1vw;
}
.flow ul li div span:nth-child(2) {
  margin-right: 1.5vw;
}

.devic-warning {
  width: 100%;
  height: 23.5vh;
}
.devic-warning .ul-title {
  width: 17.2vw;
  height: 2.8vh;
  display: flex;
  font-size: 0.6vw;
  color: #fff;
  margin-left: 0.7vw;
  align-items: center;
  justify-content: space-between;
  font-family: SIMHEI;
}
/* .devic-warning .ul-title span {
 margin-right:24px ;
} */

.devic-warning ul {
  width: 100%;
  height: 22vh;
  font-size: 12px;
}

.devic-warning ul li {
  width: 17.2vw;
  height: 3.1vh;
  margin-left: 0.7vw;
  background: url("../assets/img/devicWL.png") no-repeat;
  background-size: 100% auto;
  display: flex;
  justify-content: space-between;
  line-height: 3.2vh;
  color: #fff;
  margin-bottom: 0.9vh;
  font-family: SIMHEI;
}

/* .devic-warning ul li span {
    margin-right:24px ;
} */

.min-pa {
  width: 100%;
  height: 20vh;
}

.right {
  width: 26.7%;
  height: 90vh;
  position: absolute;
  right: 0;
  top: 8vh;
}

.back {
  width: 1.8vw;
  height: 3.6vh;
  position: absolute;
  background: url("../assets/img/back.png") no-repeat;
  right: 2.1vw;
  top: 0;
  cursor: pointer;
  z-index: 6;
}
.yuan-right {
  position: absolute;
  width: 12.81vw;
  height: 81vh;
  background: url("../assets/img/yuanright.png") no-repeat;
  background-size: 100% 100%;
  margin-top: 5.2vh;
  pointer-events: none;
}
.yuan-data {
  width: 25.5vw;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.yuan-data .ulOne {
  width: 100%;
  height: 10%;
  display: flex;
  flex-wrap: wrap;
}
.yuan-data .ulTwo {
  width: 100%;
  height: 20%;
  display: flex;
  flex-wrap: wrap;
}
.yuan-data .ulThree {
  width: 100%;
  height: 40%;
  display: flex;
  flex-wrap: wrap;
}

.yuan-data .ulFour {
  width: 100%;
  height: 10%;
  display: flex;
  flex-wrap: wrap;
}
.yuan-data .ulFive {
  width: 100%;
  height: 20%;
  display: flex;
  flex-wrap: wrap;
}

.yuan-data ul li {
  width: 14vw;
  height: 5.2vh;
  background: url("../assets/img/deng.png") no-repeat;
  display: flex;
  align-items: flex-end;
}
.yuan-data ul li.dengActive {
  background: url("../assets/img/dengActive.png") no-repeat;
  text-shadow: 2px 2px #ccc;
}
.yuan-data ul li.dengActiveRed {
  background: url("../assets/img/dengActiveRed.png") no-repeat;
  text-shadow: 2px 2px #ccc;
}
.yuan-data .ulOne li:nth-child(1) {
  margin-left: 0.52vw;
}
.yuan-data .ulTwo li:nth-child(1) {
  margin-left: 6.8vw;
}
.yuan-data .ulTwo li:nth-child(2) {
  margin-left: 9.89vw;
}
.yuan-data .ulThree li:nth-child(1) {
  margin-left: 12vw;
}
.yuan-data .ulThree li:nth-child(2) {
  margin-left: 13vw;
}
.yuan-data .ulThree li:nth-child(3) {
  margin-left: 13.5vw;
}
.yuan-data .ulThree li:nth-child(4) {
  margin-left: 13vw;
}
.yuan-data .ulFour li:nth-child(1) {
  margin-left: 12vw;
}
.yuan-data .ulFive li:nth-child(1) {
  margin-left: 9.3vw;
}
.yuan-data .ulFive li:nth-child(2) {
  margin-left: 5.7vw;
}
.yuan-data ul li span {
  height: 3.8vh;
  font-size: 1.25vw;
  color: #fff;
  margin-left: 3.2vw;
  border-bottom: 1px solid #c5d2d8;
  font-family: SIMHEI;
}
</style>
